<div class="card-widget" *ngIf="!!widget">
  <div [ngClass]="{ 'cursor-pointer': isInteractive && !isDisabled, disabled: isDisabled }" class="text-center">
    <div class="text-primary pt-3" (click)="isSettingsAllowed && onWidgetTileButtonClick('Settings')">
      <img class="h-40" [src]="tileIconSrc" alt="Widget Icon" />
    </div>
    <div class="text-icon-view">{{ widget.widget?.name }}</div>
  </div>
  <div
    *ngIf="isInteractive"
    [ngbTooltip]="disabledTooltip"
    placement="bottom"
    class="position-absolute top-0 end-0 form-check form-switch form-switch-md mt-2"
  >
    <input
      class="form-check-input"
      type="checkbox"
      id="SwitchCheckSizemd"
      [class.cursor-pointer]="isInteractive"
      [checked]="!isDisabled"
      (click)="onToggleWidgetState()"
    />
    <label class="form-check-label" for="SwitchCheckSizemd"></label>
  </div>
  <div
    *ngIf="hasWarning"
    class="position-absolute top-0 warning font-size-20 mt-2"
    [ngbTooltip]="warningMessage"
  >
    <i
      [ngClass]="{
        'mdi dripicons-warning': warningMessage,
        'fas fa-exclamation-circle': !warningMessage && !isDisabled
      }"
      class="text-warning"
    ></i>
  </div>

  <ng-container *ngFor="let buttonEntry of buttons | keyvalue">
    <ng-container *ngTemplateOutlet="tileButton; context: { btn: buttonEntry.value }"></ng-container>
  </ng-container>
</div>


<ng-template #tileButton let-btn="btn">
  <div
    *ngIf="btn.visible"
    [class.disabled]="isDisabled"
    [class]="btn.classList"
    [ngbTooltip]="btn.tooltip"
    (click)="onWidgetTileButtonClick(btn.name)"
    >
    <a class="text-secondary"><i class="{{ btn.icon }} font-size-22"></i></a>
  </div>
</ng-template>
